"use client";

import type { StorefrontExternalBookingDto } from "@tripcart/shared";
import { createContext, useContext } from "react";

/**
 * How this tour books when it books on the agency's own site — `null` for the
 * TripCart checkout. Provided once by the detail view from the tour DTO, so
 * the departure rows and package cards read the same answer as the rail and
 * the sticky bar instead of each deriving it.
 */
export const ExternalBookingContext =
  createContext<StorefrontExternalBookingDto | null>(null);

export function useExternalBooking(): StorefrontExternalBookingDto | null {
  return useContext(ExternalBookingContext);
}
